import {
    PATH_COURSE,
    PATH_LOCATION,
    PATH_GIFT_CARD,
    PATH_CART,
    PATH_SUBSCRIBE
} from './constants';

import ShoppingCartPage from './pages/ShoppingCartPage';
import NemoCoursesPage from './pages/NemoCoursesPage';
import NemoLocationsPage from './pages/NemoLocationsPage';
import SubscribeForm from './pages/SubscribeForm';

const routeConfig = [
    {
        path: "/framed-courses",
        exact: true,
        component: NemoCoursesPage
    },
    {
        path: "/framed-locations",
        exact: true,
        component: NemoLocationsPage
    },
    {
        path: `/${PATH_SUBSCRIBE}`,
        exact: true,
        component: SubscribeForm
    },
    {
        path: [
            `/${PATH_GIFT_CARD}/:amount`,
            `/${PATH_COURSE}/:programSlug/:locationSlug/:experienceId`,
            `/${PATH_COURSE}/:programSlug/:locationSlug`,
            `/${PATH_COURSE}/:programSlug`,
            `/${PATH_LOCATION}/:locationSlug/:programSlug`,
            `/${PATH_LOCATION}/:locationSlug`,
            `/${PATH_CART}`
        ],
        component: ShoppingCartPage
    }
];
export default routeConfig;
